import { createContext, useContext } from "react";

/**
 * Overlay de ficha sobre el pipeline (sin MemoryRouter): el formulario lee
 * `embeddedCaptacion` / `embeddedReturnTo` aquí en lugar de `location.state`.
 * `registerFlushSave` / `flushSave` permiten guardar borrador al pulsar «Cerrar ficha».
 * @type {React.Context<null | {
 *   onClose: () => void,
 *   embeddedCaptacion: object,
 *   embeddedReturnTo?: string,
 *   registerFlushSave?: (fn: (() => Promise<boolean>) | null) => void,
 * }>}
 */
export const PropiedadFormEmbedContext = createContext(null);

export function usePropiedadFormEmbed() {
  return useContext(PropiedadFormEmbedContext);
}
